var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0V17.8947H1.05263V4.21053H3.15789V15.7895H17.8947V2.10526H13.6842V0H20ZM6.31579 0C9.14606 0 11.4545 2.23401 11.5741 5.03485L11.5789 5.26316L11.5789 9.0371L13.9925 6.6241L15.4812 8.11274L10.5263 13.0676L5.57147 8.11274L7.06011 6.6241L9.47368 9.0371V5.26316C9.47368 3.58139 8.15903 2.20667 6.50134 2.11062L6.31579 2.10526H0V0H6.31579Z",
    fill: "#498e2b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIconGreen);
export default __webpack_public_path__ + "static/media/import-icon-green.fb5fb5110ab01647d514833a99e93b06.svg";
export { ForwardRef as ReactComponent };